import React, { useState, useEffect } from 'react';

import { Description, Count, ShowMoreContainer, Label, Title } from './StyledFilterContentType';

import { ContentTypeMeta } from '.';

import Radio from '_utils/components/Corporate/Radio';
import ShowMore from '_utils/components/Corporate/ShowMore';
import { equalIds } from '_utils/data';
import { useTranslation } from 'react-i18next';

type FilterContentTypeProps = {
  selectedContentTypeFilter: string;
  contentTypes: ContentTypeMeta[];
  onChange: (e) => void;
};

type ContentTypeFilterProps = {
  contentType: ContentTypeMeta;
  checked: boolean;
  onChange: (e) => void;
};

const ContentTypeOption: React.FC<ContentTypeFilterProps> = ({
  contentType: { title, description, numResults, id },
  checked,
  onChange
}) => (
    <Radio
      id={`content-type-radio-${id}`}
      name="filterContentType"
      value={id}
      onChange={onChange}
      checked={checked}
    >
      <Label>
        <Title className={checked ? 'selected' : ''}>{title}</Title>
        {numResults && <Count> ({numResults})</Count>}
      </Label>
      {description && <Description>{description}</Description>}
    </Radio>
  );

const FilterContentType: React.FC<FilterContentTypeProps> = ({
  contentTypes,
  selectedContentTypeFilter,
  onChange
}) => {
  const results = contentTypes || [];
  // const title = filterGroup?.results || null;
  const primaryResults = results.slice(0, 4);
  const secondaryResults = results.slice(4);
  const [canShowMore, setCanShowMore] = useState(secondaryResults.length > 0);
  const [showingMore, setShowingMore] = useState(false);
  const [t] = useTranslation();

  useEffect(() => {
    setCanShowMore(secondaryResults && secondaryResults.length > 0 && !showingMore);
  }, [secondaryResults, showingMore]);

  if (!results) {
    return null;
  }

  return (
    <>
      {primaryResults &&
        primaryResults.map((result) => (
          <ContentTypeOption
            key={`ContentOption-${result.id}`}
            contentType={result}
            checked={equalIds(result.id, selectedContentTypeFilter)}
            onChange={onChange}
          />
        ))}
      {canShowMore && (
        <ShowMoreContainer>
          <ShowMore
            label={t('search-filter-content-type-show-more-label')}
            title={'search-filter-accessible-show-more-content-types-label'}
            count={secondaryResults.length}
            onClick={() => {
              setShowingMore(true);
              setCanShowMore(false);
            }}
          />
        </ShowMoreContainer>
      )}
      {showingMore &&
        secondaryResults &&
        secondaryResults.map((result) => (
          <ContentTypeOption
            key={`ContentOption-${result.id}`}
            contentType={result}
            checked={equalIds(result.id, selectedContentTypeFilter)}
            onChange={onChange}
          />
        ))}
    </>
  );
};

export default FilterContentType;
